import React, { useState } from 'react';
import './DCarousel.css';
const DAboutus = () => {
  const [banners, setBanners] = useState([
    {
      id: 1,
      title: 'offer1',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=200&fit=crop',
      linkUrl: '/products?category=offers'
    }
  ]);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingBanner, setEditingBanner] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    linkUrl: '',
    image: ''
  });

  const handleEdit = (id) => {
    const banner = banners.find(b => b.id === id);
    if (banner) {
      setEditingBanner(banner);
      setFormData({
        title: banner.title,
        linkUrl: banner.linkUrl || '',
        image: banner.image
      });
      setIsEditModalOpen(true);
    }
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this banner?')) {
      setBanners(banners.filter(banner => banner.id !== id));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // In a real application, you would upload the file to a server
      // For demo purposes, we'll create a temporary URL
      const imageUrl = URL.createObjectURL(file);
      setFormData(prev => ({
        ...prev,
        image: imageUrl
      }));
    }
  };

  const handleUpdateBanner = (e) => {
    e.preventDefault();
    if (editingBanner) {
      setBanners(banners.map(banner => 
        banner.id === editingBanner.id 
          ? { ...banner, ...formData }
          : banner
      ));
      setIsEditModalOpen(false);
      setEditingBanner(null);
      setFormData({ title: '', linkUrl: '', image: '' });
    }
  };

  const handleCancel = () => {
    setIsEditModalOpen(false);
    setEditingBanner(null);
    setFormData({ title: '', linkUrl: '', image: '' });
  };

  return (
    <div className="banner-management-container">
      <div className="banner-management-header">
        <h1 className="page-title">Why Choose Us Management</h1>
        <button className="add-banner-btn">+ Add New Banner</button>
      </div>

      <div className="banner-table-container">
        <table className="banner-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Titles</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {banners.map((banner) => (
              <tr key={banner.id} className="banner-row">
                <td className="image-cell">
                  <div className="banner-image-container">
                    <img 
                      src={banner.image} 
                      alt={banner.title}
                      className="banner-thumbnail"
                    />
                    {banner.id === 1 && (
                      <div className="banner-overlay">
                        <div className="overlay-text">
                          <div className="shop-text">SHOP by NEW ARRIVALS</div>
                          <div className="season-text">New Season Of Style</div>
                        </div>
                      </div>
                    )}
                    {banner.id === 2 && (
                      <div className="banner-overlay dark">
                        <div className="overlay-text">
                          <div className="collection-text">COLLECTION</div>
                          <div className="bag-icon">👜</div>
                        </div>
                      </div>
                    )}
                  </div>
                </td>
                <td className="title-cell">
                  <span className="banner-title">{banner.title}</span>
                </td>
                <td className="actions-cell">
                  <div className="action-buttons">
                    <button 
                      className="edit-btn"
                      onClick={() => handleEdit(banner.id)}
                      title="Edit"
                    >
                      ✏️
                    </button>
                    <button 
                      className="delete-btn"
                      onClick={() => handleDelete(banner.id)}
                      title="Delete"
                    >
                      🗑️
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Edit Modal */}
      {isEditModalOpen && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header">
              <h2 className="modal-title">Edit Offer Banner</h2>
              <button className="modal-close" onClick={handleCancel}>×</button>
            </div>
            
            <form onSubmit={handleUpdateBanner} className="modal-form">
              <div className="form-group">
                <label htmlFor="title" className="form-label">Banner Title</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="linkUrl" className="form-label">Link URL (Optional)</label>
                <input
                  type="text"
                  id="linkUrl"
                  name="linkUrl"
                  value={formData.linkUrl}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="e.g., /products?category=summer"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Current Image</label>
                <div className="current-image-container">
                  <img 
                    src={formData.image} 
                    alt="Current banner" 
                    className="current-image"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="imageFile" className="form-label">Change Image (Optional)</label>
                <input
                  type="file"
                  id="imageFile"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="form-file-input"
                />
                <p className="form-hint">Leave empty to keep current image. Recommended size: 1200x500 pixels (5MB max)</p>
              </div>

              <div className="modal-actions">
                <button type="button" onClick={handleCancel} className="cancel-btn">
                  Cancel
                </button>
                <button type="submit" className="update-btn">
                  Update Banner
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default DAboutus;